<template>
  <div class="System">
    <h1>程序零件映射表</h1>
    <button v-on:click="find_click()">查询</button>
    <table border="3" width="1300px"> <!--border：表格边框，width：表格宽度-->
      <caption></caption> <!--标题标签，居中显示，仅有一个标题-->
      <tr>
        <th>id</th>
        <th>主程序名称</th>
        <th>零件号</th>
        <th>零件名称</th>
        <th>规格</th>
        <th>备注</th>
 
        <th colspan="2">操作</th>
      </tr>
      <tr v-for="item in items">
        <td>
          <label> {{ item.id }}</label>
        </td>
        <td>
          <label> {{ item.mainprogram }}</label>
        </td>
        <td>
          <label> {{ item.productCode }}</label>
        </td>
        <td>
          <label> {{ item.productName }}</label>
        </td>
        <td>
          <label> {{ item.specification }}</label>
        </td>
        <td>
          <label> {{ item.comments }}</label>
        </td>
        <td>
          <button v-on:click="delete_click(item.id)">删除</button>
        </td>
        <td>
          <button v-on:click="edit_click(item)">编辑</button>
        </td>
      </tr>
    </table>
    <button v-on:click="add_click()">新增</button>

    <div class="dialog" v-if="showModal">

      <h1>新增 <button v-on:click="close_click()">关闭</button></h1>
 
      <p>

      <p>程序名称:</p>
      <input v-model="program" placeholder="edit me" />

      <p>零件号:</p>
      <input v-model="partcode" placeholder="edit me" />

      <p>零件名称:</p>
      <input v-model="partname" placeholder="edit me" />

      <p>规格:</p>
      <input v-model="specification" placeholder="edit me" />

      <p>备注:</p>
      <input v-model="comments" placeholder="edit me" />

      </p>
      <button v-on:click="addNew()">提交</button>


    </div>

    <div class="dialogEdit" v-if="showEditModal">

      <h1>编辑 <button v-on:click="close_click()">关闭</button></h1>
      <p>Id:</p>
      <label> {{ id }} </label>

      <p>

      <p>程序名称:</p>
      <input v-model="program" placeholder="edit me" />

      <p>零件号:</p>
      <input v-model="partcode" placeholder="edit me" />

      <p>零件名称:</p>
      <input v-model="partname" placeholder="edit me" />

      <p>规格:</p>
      <input v-model="specification" placeholder="edit me" />

      <p>备注:</p>
      <input v-model="comments" placeholder="edit me" />

      </p>

      <button v-on:click="update()">更新</button>


    </div>
  </div>
</template>


<script>
export default {
  name: 'MappingTable',

  data() {
    return {
      url:'http://192.168.132.65:8000/work/parts/' ,
      showEditModal: false,
      showModal: false,
      refreshTime: '',
      id: '',
      program:'',
      partname:'',
      partcode:'',
      specification:'',
      comments:'',
      item: {},
      items: [
       
      ]
    }
  },
  mounted() {
    let _this = this;
    this.$data.refreshTime = this.$cookies.get('refreshTime')
    this.find_click();

  },
  methods: {
    click() {
      this.$cookies.set('refreshTime', this.$data.refreshTime)
    },
    delete_click(id) {
      let _this = this;
      this.$http.delete(this.$data.url+ id)
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
          _this.find_click();
        })
        .catch(function (error) {
          console.log(error);
        });

      this.find_click();
    },
    add_click() {
      this.id = "",
      this.program = "";
      this.partcode = "";
      this.partname = "";
      this.specification = "";
      this.comments = "";
      this.close_click();
      this.$data.showModal = true;
    },
    edit_click(item) {
      this.id = item.id;
      this.program = item.mainprogram;
      this.partcode = item.productCode;
      this.partname = item.productName;
      this.specification = item.specification;
      this.comments = item.comments;
      this.close_click();
      this.$data.showEditModal = true;
    },
    find_click() {
      let _this = this;
      this.$http.get(this.$data.url)
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          _this.$data.items = response.data.data;

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    close_click() {
      this.$data.showModal = false;
      this.$data.showEditModal = false;
    },
    addNew() {
      let _this = this;

      this.$http.post(this.$data.url, { 
        mainprogram: this.program,
        productCode: this.partcode,
        productName: this.partname,
        drawing: this.program+".spf",
        specification: this.specification,
        comments: this.comments
      })
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          _this.find_click();
        })
        .catch(function (error) {
          console.log(error);
        });


    },
    update() {
      this.$http.put(this.$data.url, {
        mainprogram: this.program,
        productCode: this.partcode,
        productName: this.partname,
        drawing: this.program+".spf",
        specification: this.specification,
        comments: this.comments,
        id:this.id
      })
        .then(function (response) {

          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);
          _this.find_click();


        })
        .catch(function (error) {
          console.log(error);
        });

      this.find_click();
    }

  }
}
</script>

<style lang="less">
.dialog {
  box-sizing: border-box;
  width: 40%;
  background-color: rgba(197, 245, 199, 0.7);
  border-radius: 3px;

}

.dialogEdit {
  box-sizing: border-box;
  width: 40%;
  background-color: rgba(163, 178, 241, 0.7);
  border-radius: 3px;

}
</style>